
import React from "react";
import Slider from "react-slick";
import { useState , useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config";


export default function CommentsSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

    const [comments, setComments] = useState([]);
  
    const fetchComments = async () => {
      try {
        const res = await axios.get(`${API_URL}/comments`);
        setComments(res.data);
      } catch (err) {
        console.error(err);
      }
    };
  
    useEffect(() => {
      fetchComments();
    }, []);

    
  return (
    <div className="max-w-2xl  mx-auto my-8  w-[40%8]">
      <Slider {...settings}>
        {comments.map((comment, index) => (
       
  <div key={index} className="bg-white p-6 flex flex-col items-center text-center ">
               <center> {comment.image ? (
                 <img
                   src={comment.image}
                   alt={comment.name}
                   className="rounded-full mx-auto items-center
                    object-cover mb-4 justify-center w-20 h-20 border-2 border-green-300 "
                 />
               ) : (
                 <div className="rounded-full mx-auto items-center flex justify-center
                  mb-4 w-20 h-20 border-2 border-green-300 bg-blue-500 text-white text-2xl font-bold">
                   {comment.name?.charAt(0)?.toUpperCase() || '?'}
                 </div>
               )}</center>  
            
<div className="relativ">
                <h3 className="text-lg font-semibold text-gray-800">{comment.name}</h3>
            <p className="text-yellow-500 text-sm mb-2">
              {"★".repeat(comment.rating) + "☆".repeat(5 - comment.rating)}
            </p>
</div>  
  <p className=" object-cover text-gray-700 py-4 my-4 bg-blue-50 italic " >"{comment.message}"</p>


          </div>
        ))}
      </Slider>
    </div>
  );
}
